export interface GoalsModel {
    studentGoalId?: number;
	name: string;
    due: string;
    createdDate?: number;
    createdByName?: string;
    updatedDate?: number;
    updatedByName?: string;
    description?: string;
    byStaff?: boolean;
    goalTasks: GoalTasksModel[];
}

export interface GoalTasksModel {
    goalTaskId?: number;
    name: string;
    createdById?: number;
    due: string;
    createdDate?: string;
    updatedDate?: number;
    updatedById?: number;
    studentGoalId?: number;
    isDone?: boolean;
    ByStaff?: boolean;
}

export interface UpdateTaskModel {
    goalTaskId: number;
    isDone: boolean;
}

export enum GoalStatusModel {
    NOT_STARTED = 1,
    IN_PROGRESS = 2,
    COMPLETED = 3
}

export enum GoalButtonActions {
    CONFIRM = 'confirm',
    UPDATE = 'update',
    DELETE = 'delete',
}

export enum RefreshEvents {
    REFRESH_RISK_COUNTER = "refresh_risk_counter",
    REFRESH_ALL_GOALS = "refresh_all_goals"
}